<template>
  <section>
    <div class="title">{{ title }}</div>
    <div class="list">
      <Badge v-for="(item, index) in skills" :key="index" :text="item" />
    </div>
  </section>
</template>

<script>
import Badge from "./ui/badge"
export default {
  components: { Badge },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      skills: [
        "Vue.js",
        "React",
        "Node.js",
        "JavaScript",
        "TypeScript",
        "GitHub",
        "Amazone AWS",
        "Serverless Framework",
        "Python3",
        "DJango Framework"
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
    letter-spacing: -1px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
